import React from 'react';

const HeroSection = ({ heroData }) => {
    console.log('Hero data received:', heroData);
    return (
        <div className="relative h-screen w-full overflow-hidden">
            {/* Background Image/Video */}
            {heroData?.backgroundVideo ? (
                <video
                    autoPlay
                    muted
                    loop
                    className="absolute inset-0 w-full h-full object-cover"
                >
                    <source src={heroData.backgroundVideo} type="video/mp4" />
                </video>
            ) : (
                <div
                    className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
                    style={{
                        backgroundImage: heroData?.backgroundImage
                            ? `url(${heroData.backgroundImage})`
                            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    }}
                />
            )}

            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-40" />

            {/* Content */}
            <div className="relative z-10 h-full flex items-center justify-center text-center text-white">
                <div className="max-w-4xl mx-auto px-4">
                    <h1 className="text-5xl md:text-7xl font-light mb-4 tracking-wide">
                        {heroData?.title || "Savana Ashlea"}
                    </h1>
                    <p className="text-xl md:text-2xl font-light tracking-wider opacity-90">
                        {heroData?.subtitle || "Artist • Photographer • Yoga Instructor"}
                    </p>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
            </div>
        </div>
    );
};

export default HeroSection;